import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './ComparisonTable.scss';

// @ts-ignore
import Fade from 'react-reveal/Fade';

// @ts-ignore
import Loader from '../Loader/Loader';

import PriceContainer from '../PriceContainer/PriceContainer';
import CONFIG from '../../../config';
import HoverImage from '../Image/HoverImage';

interface IComparisonTableProps {
  context?: IContent;
  products?: any;
}

const ComparisonTable = ({ context, products }: IComparisonTableProps) => {
  const { comparison_table } = context;
  const productsFromSheet = CONFIG.isUPC
    ? comparison_table.products.upc
    : comparison_table.products.web;
  const columnHeadList: any = [];
  const columnFootList: any = [];
  const listProductsMobile: any = [];
  const [mobileTooltipShowed, setMobileTooltipShowed]: any = useState(null);

  const tickPathDark = require('../../../assets/extraction_icon_dark.png');
  const tickPathLight = require('../../../assets/extraction_icon_light.png');
  const infoCirclePath = require('../../../assets/info-circle.svg');
  const infoCirclePathYellow = require('../../../assets/info-circle-yellow.svg');

  const isTicked = (rowIndex: number, productID: number) => {
    const productFound = productsFromSheet.filter(
      (product: any) => product.id === productID
    );
    if (
      productFound.length !== 1 ||
      (productFound.length === 1 && !productFound[0].rows)
    ) {
      return false;
    }
    return productFound[0].rows[rowIndex];
  };

  const getImage = (product: any) => {
    const imagesList = product.originalData.image_groups
      ? product.originalData.image_groups.filter(
          (image: any) => image.view_type === 'large'
        )
      : null;
    const image =
      imagesList.length === 1 && imagesList[0].images.length > 0
        ? imagesList[0].images[0]
        : null;

    return image ? image.link : null;
  };

  const atLeastOneTicked = (rowIndex: any) => {
    return productsFromSheet.some(
      (product: any) => isTicked(rowIndex, product.id) === 'TRUE'
    );
  };

  productsFromSheet.forEach((product: any, index: number) => {
    const productFound = products[product.id];
    if (productFound) {
      const imagePath = getImage(productFound);

      columnHeadList.push(
        <th key={`head${index}`}>
          <Fade delay={index * 200} bottom duration={600} distance="10px">
            <div className="image">
              <img src={imagePath} alt={productFound.fullName} />
            </div>
            <div className="edition-name">{productFound.name.edition}</div>
          </Fade>
        </th>
      );

      columnFootList.push(
        <Fade delay={index * 200} duration={600} key={`foot${index}`}>
          <td>
            {product.price_info && (
              <div className="price-flag">{product.price_info}</div>
            )}
            <PriceContainer product={productFound} />
          </td>
        </Fade>
      );

      listProductsMobile.push(
        <div className="comparison-mobile-item" key={index}>
          <div className="content">
            <div className="image">
              <img src={imagePath} alt={productFound.fullName} />
            </div>
            <div className="edition-name">{productFound.name.edition}</div>
            <ul className="list-features">
              {comparison_table.rows.map((row: any, indexFeature: number) => (
                <li key={indexFeature} className="feature">
                  <div
                    className="feature-title"
                    style={{
                      color: indexFeature % 2 === 0 ? '#FFD900' : '#102831'
                    }}
                  >
                    {row.title}
                    {row.info && (
                      <button
                        className={`tooltip-feature${
                          mobileTooltipShowed === `${index}, ${indexFeature}`
                            ? ' showed'
                            : ''
                        }`}
                        onClick={(e) =>
                          mobileTooltipShowed === `${index}, ${indexFeature}`
                            ? setMobileTooltipShowed(null)
                            : setMobileTooltipShowed(
                                `${index}, ${indexFeature}`
                              )
                        }
                      >
                        <img
                          className="info-circle"
                          src={
                            indexFeature % 2 === 0
                              ? infoCirclePathYellow
                              : infoCirclePath
                          }
                          alt=""
                        />
                        <HoverImage
                          className="image-hover"
                          imageName={row.info}
                          altText=""
                          loaderOptions={{ width: '150px', height: '200px' }}
                          useOnlyFallback={true}
                        />
                      </button>
                    )}
                  </div>
                  <div className="feature-tick">
                    {isTicked(indexFeature, productFound.id) === 'TRUE' ? (
                      <img
                        src={
                          indexFeature % 2 === 0 ? tickPathLight : tickPathDark
                        }
                        alt=""
                      />
                    ) : null}
                  </div>
                </li>
              ))}
            </ul>
            {product.price_info && (
              <div className="price-flag">{product.price_info}</div>
            )}
            <PriceContainer product={productFound} />
          </div>
        </div>
      );
    }
  });

  return (
    <div className="comparison-table">
      {Object.keys(products).length === 0 ? (
        <Loader customColor="white" />
      ) : (
        <div>
          <div className="comparison-mobile">{listProductsMobile}</div>
          <table className="comparison-table">
            <thead>
              <tr>
                <th></th>
                {columnHeadList}
              </tr>
            </thead>
            <tbody>
              {comparison_table.rows.map(
                (row: any, indexRow: number) =>
                  atLeastOneTicked(indexRow) && (
                    <tr key={indexRow}>
                      <td>
                        <div
                          className="feature-title"
                          style={{
                            color: indexRow % 2 === 0 ? '#FFD900' : '#102831'
                          }}
                        >
                          {row.title}
                          {row.info && (
                            <button className="tooltip-feature">
                              <img
                                className="info-circle"
                                src={
                                  indexRow % 2 === 0
                                    ? infoCirclePathYellow
                                    : infoCirclePath
                                }
                                alt=""
                              />
                              <HoverImage
                                className="image-hover"
                                imageName={row.info}
                                altText=""
                                loaderOptions={{
                                  width: '150px',
                                  height: '200px'
                                }}
                                useOnlyFallback={true}
                              />
                            </button>
                          )}
                        </div>
                      </td>
                      {productsFromSheet.map(
                        (product: any, indexCol: number) => {
                          const productFound = products[product.id];
                          return (
                            productFound && (
                              <Fade
                                delay={indexCol * 200}
                                duration={600}
                                key={indexCol}
                              >
                                <td>
                                  {isTicked(indexRow, product.id) === 'TRUE' ? (
                                    <img
                                      src={
                                        indexRow % 2 === 0
                                          ? tickPathLight
                                          : tickPathDark
                                      }
                                      alt=""
                                    />
                                  ) : null}
                                </td>
                              </Fade>
                            )
                          );
                        }
                      )}
                    </tr>
                  )
              )}
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                {columnFootList}
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.app.products
});

export default connect(mapStateToProps)(withContent(ComparisonTable));
